import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { AlertType } from "../domain/snack-bar.model";
import { SnackBarService } from "../application/snack-bar.service";
import { NgClass } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: "app-alert",
  templateUrl: "./alert.html",
  styleUrls: ["./alert.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    MatIconButton,
    MatIcon
  ],
})
export class Alert {
  private snackBarService = inject(SnackBarService);
  withCloseIcon = input(false);
  type = input<AlertType>(AlertType.info);
  alertType = AlertType;

  close() {
    this.snackBarService.close();
  }
}
